export const threeSeconds = 3000;
export const emailRegexPattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const onlyLettersAndHyphen = /[^a-zA-Z\- ]/;

export const agenciesHeaders = [
  { header: 'agencyName', label: 'Agency Name' },
  { header: 'agencyID', label: 'Agency Id' },
  { header: 'partnerID', label: 'Partner Id' },
  { header: 'partnerAgencyID', label: 'Partner Agency Id' },
  { header: 'active', label: 'Active' },
];

export const agenciesFlyout = 'agencies';
export const agenciesCreationFlyout = 'agenciesCreation';
export const createAgencies = 'Create Agency';

export const createCredentialSuccessAlert = {
  message: 'You successfully created the Credential.',
  color: 'success',
  icon: 'check',
};

export const editCredentialSuccessAlert = {
  message: 'You successfully edited the Credential.',
  color: 'success',
  icon: 'check',
};

export const agenciesUpdateSuccessAlert = {
  message: 'You successfully edited the Agency.',
  color: 'success',
  icon: 'check',
};

export const agenciesCreationSuccessAlert = {
  message: 'You successfully added an Agency.',
  color: 'success',
  icon: 'check',
};

export const agenciesFieldInitialValues = {
  name: '',
  partnerAgencyID: '',
  partnerID: '',
};

export const credentialsCreationSuccessAlert = {
  message: 'Credentials was created successfully. Refresh page to see changes.',
  color: 'success',
  icon: 'check',
};

export const profileInfo = {
  agencyNameLabel: 'Agency Name:',
  agencyNameId: 'agencyName',
  agencyIdLabel: 'Agency ID:',
  agencyId: 'agencyId',
  partnerIdLabel: 'Partner ID:',
  partnerId: 'partnerId',
  partnerAgencyIdLabel: 'Partner Agency ID:',
  partnerAgencyId: 'partnerAgencyId',
  statusLabel: 'Status:',
  statusId: 'status',
  profileFormEditButtonLabel: 'Edit Profile',
};

export const profileForm = {
  agencyNameLabel: 'Agency Name:',
  agencyNameId: 'name',
  statusToggleLabel: 'Agency activation status',
  statusToggleId: 'status',
};

export const profileInfoDefaultValues = {
  agencyName: '',
  agencyId: '',
  partnerAgencyId: '',
  partnerId: '',
  active: false,
};

export const profileFormDefaultValues = {
  agencyName: '',
  active: false,
};

export const text = {
  cancel: 'Cancel',
  save: 'Save',
  saving: 'Saving...',
  loading: 'Loading...',
  creating: 'Creating...',
  updateMode: 'update',
  createMode: 'create',
  generalError: 'A system error occurred. Please try again later.',
  createAgencyLabel: 'Create',
  createCredentialFormTitle: 'Create Credential',
  mediumSize: 'md',
};

export const credentialForm = {
  credentialStatusLabel: 'Credential activation status',
  credentialStatusId: 'status',
  userNameLabel: 'User Name',
  userNameId: 'credential_form_usernamefield_id',
  passwordLabel: 'Password',
  passwordId: 'credential_form_passwordfield_id',
  nodePickerLabel: 'Node',
  nodePickerId: 'aggregatorID',
  medicaidLabel: 'Medicaid ID',
  medicaidId: 'businessMedicaidID',
  businessNameLabel: 'Business Name',
  businessNameId: 'businessName',
  entityIdLabel: 'Entity ID',
  entityIdId: 'businessEntityID',
  npiFieldLabel: 'NPI',
  npiFieldId: 'businessNPI',
  taxonomyLabel: 'Taxonomy',
  taxonomyId: 'businessTaxonomy',
  einLabel: 'EIN',
  einId: 'businessEIN',
  emailLabel: 'Email',
  emailId: 'email',
  claimLayoutNameLabel: 'Claim Layout Name',
  claimLayoutNameId: 'claimLayoutName',
  vendorIdLabel: 'Vendor ID',
  vendorIdId: 'vendorID',
  includeBillingLabel: 'Include Billing',
  includeBillingId: 'includeBilling',
  splitVisitLabel: 'Split Visit',
  splitVisitId: 'splitVisit',
};
